import React, { Component } from "react";

import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import menuCloseIcon from "../img/icons/close-icon.png";
//Image imports
import menuClosedIcon from "../img/icons/menu-icon.png";

export default class MenuComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      padding: 0,
    };
    this.handleClick = this.handleClick.bind(this);
    this.getValues = this.getValues.bind(this);
  }
  componentDidMount() {
    this.getValues();
    window.addEventListener("resize", this.getValues());
  }
  getValues() {
    var bodySize = document.getElementsByTagName("body")[0].clientWidth;
    var containerSize = document.getElementsByClassName("container")[0]
      .clientWidth;
    let padding = (bodySize - containerSize) / 2;
    if (padding > 0)
      this.setState({
        padding: padding + "px",
      });
  }
  handleClick() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }
  render() {
    const { menuList } = this.props;
    const style = {
      paddingRight: this.state.padding,
    };
    return (
      <div className="menu-section">
        <div className="menu-block">
          <div className="menu-button" onClick={(e) => this.handleClick()}>
            <button onClick={() => this.handleClick}>
              <img src={menuClosedIcon} alt="" aria-hidden="true" />
            </button>
          </div>
        </div>
        <div
          className={
            this.state.collapse ? "menu-collapse show" : "menu-collapse"
          }
          style={this.state.collapse ? style : {}}
        >
          <ul>
            <li className="close-button">
              <button onClick={() => this.handleClick()}>
                <img src={menuCloseIcon} alt="" aria-hidden="true" />
              </button>
            </li>
            {menuList.map((item, index) => {
              console.log(item.title);
              if (
                ["projetos", "millennials", "MMps", "videos"].indexOf(
                  item.title
                ) == -1
              )
                return (
                  <li key={index}>
                    <Link to={item.link} onClick={() => this.handleClick()}>
                      {item.title}
                    </Link>
                  </li>
                );
            })}
          </ul>
        </div>
      </div>
    );
  }
}

MenuComponent.propType = {
  menuList: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/menu.js